import styled, { css, keyframes } from 'styled-components'
import { device } from '../../../styles/GlobalVariables'
import { RING_THIRDS, ringMask } from './StoriesRail.style'

/** a wait shorter than this shows no loader: a clip that starts fast cuts straight in */
export const LOADER_DELAY_MS = 600

export const loaderTurn = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const loaderAppear = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

/**
 * Figma "Loader" (24284:44750): one 2px ring in the brand thirds, 30px on
 * every screen. It turns clockwise once every 1.2s: the caller sets the
 * animation with loaderTurn, next to its own fade-in.
 */
export const storiesLoaderRing = css`
  box-sizing: border-box;
  width: 30px;
  height: 30px;
  border: 0;
  /* the mask draws the circle: a rounded box would soften its edge twice */
  border-radius: 0;
  background: ${RING_THIRDS};
  ${ringMask('2px')}
`

/**
 * Figma "M_Video Play_Loader" (24339:374895) and "D_Video Play_Loader"
 * (24339:376853): the clip's frame stays, under 80% black that covers it and
 * everything drawn on it but the close button. It fades in after
 * LOADER_DELAY_MS; the caller takes off the time already waited.
 */
export const LoadingVeil = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.8);
  animation: ${loaderAppear} 0.2s ease ${LOADER_DELAY_MS}ms both;
`

/** the Loader in the middle of the player; on mobile 0.5px right of it, as drawn */
export const LoadingSpin = styled.span`
  ${storiesLoaderRing}
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -15px 0 0 -14.5px;
  animation: ${loaderTurn} 1.2s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  ${device.regular} {
    margin: -15px 0 0 -15px;
  }
`
